import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  USAGE_CONSUMPTION_RESET,

  FETCH_STOCK_TRANSFER_APPROVERS_REQUEST,
  FETCH_STOCK_TRANSFER_APPROVERS_SUCCESS,
  FETCH_STOCK_TRANSFER_APPROVERS_ERROR,

  FETCH_STOCK_TRANSFER_APPROVERS_MISSION_REQUEST,
  FETCH_STOCK_TRANSFER_APPROVERS_MISSION_SUCCESS,
  FETCH_STOCK_TRANSFER_APPROVERS_MISSION_ERROR,

  SAVE_STOCK_TRANSFER_APPROVERS_REQUEST,
  SAVE_STOCK_TRANSFER_APPROVERS_ERROR,
  SAVE_STOCK_TRANSFER_APPROVERS_SUCCESS,

  DELETE_STOCK_TRANSFER_APPROVERS_REQUEST,
  DELETE_STOCK_TRANSFER_APPROVERS_SUCCESS,
  DELETE_STOCK_TRANSFER_APPROVERS_ERROR
} from 'actionTypes'

// List permissions
  export const fetchStockTransferApprovers = (token, query) =>
  (dispatch) => {
    dispatch(fetchStockTransferApproversRequest())

    return new Api(token, dispatch)
      .get(API_URL.STOCK_TRANSFER_APPROVERS_LIST , query)
      .then(dispatch(showSpinner()))
      .then((response) => {
    
        dispatch(fetchStockTransferApproversSucces(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchStockTransferApproversError(error))
        dispatch(hideSpinner())
      })
  }

  export const fetchStockTransferApproversRequest = () => ({
    type: FETCH_STOCK_TRANSFER_APPROVERS_REQUEST,
  })
  
  export const fetchStockTransferApproversError = (data) => ({
    type: FETCH_STOCK_TRANSFER_APPROVERS_ERROR,
    error: data
  })
  
  export const fetchStockTransferApproversSucces = (data) => ({
    type: FETCH_STOCK_TRANSFER_APPROVERS_SUCCESS,
    payload: data
  })
  
  // List missions
  export const fetchMissions = (token) => (dispatch) => {
    dispatch(fetchMissionsRequest())

    return new Api(token, dispatch)
      .get(API_URL.STOCK_TRANSFER_APPROVERS_LIST_MISSION)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(fetchMissionsSuccess(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchMissionsError(error))
        dispatch(hideSpinner())
      })
  }

  export const fetchMissionsRequest = () => ({
    type: FETCH_STOCK_TRANSFER_APPROVERS_MISSION_REQUEST,
  })
  
  export const fetchMissionsSuccess = (data) => ({
    type: FETCH_STOCK_TRANSFER_APPROVERS_MISSION_SUCCESS,
    payload: data,
  })
  
  export const fetchMissionsError = (error) => ({
    type: FETCH_STOCK_TRANSFER_APPROVERS_MISSION_ERROR,
    payload: error,
  })
  
  // Save permission
  export const preserve = (token, params, callbackSave) => (dispatch) => {
    dispatch(saveStockTransferApproversRequest())
  
    return new Api(token, dispatch)
      .post(API_URL.STOCK_TRANSFER_APPROVERS_SAVE, params)
      .then(dispatch(showSpinner()))
      .then((response) => {
  
        if(response.cdStatus === 409 || response.cdStatus === 500 || response.cdStatus === 400 ) {
          dispatch(saveStockTransferApproversError(response))
        }
  
        else { 
          dispatch(saveStockTransferApproversSuccess(response))
          dispatch(fetchMissions(token))
          callbackSave()
        }
  
      
      })
      .catch((error) => {
        dispatch(saveStockTransferApproversError(error))
      })
      .finally(() => dispatch(hideSpinner()))
  }

  
  export const saveStockTransferApproversRequest = () => ({
    type: SAVE_STOCK_TRANSFER_APPROVERS_REQUEST,
  })

  export const saveStockTransferApproversSuccess = (data) => ({
    type: SAVE_STOCK_TRANSFER_APPROVERS_SUCCESS,
    payload: data,
  })

  export const saveStockTransferApproversError = (error) => ({
    type: SAVE_STOCK_TRANSFER_APPROVERS_ERROR,
    payload: error,
  })

  // Delete permission
  export const deletePermissions = (token, params, callBackDelete) => (dispatch) => {
    dispatch(deleteStockTransferApproversRequest())
    return new Api(token, dispatch)
      .deleteWithBody(API_URL.STOCK_TRANSFER_APPROVERS_REMOVE, params)
      .then(dispatch(showSpinner()))
      .then((response) => {
        
          dispatch(deleteStockTransferApproversSuccess(response))
      })
      .catch((error) => {
        
        dispatch(deleteStockTransferApproversError(error))
      })
      .finally(() => {
        dispatch(hideSpinner())
        callBackDelete()
      })
  }
  
  export const deleteStockTransferApproversRequest = () => ({
    type: DELETE_STOCK_TRANSFER_APPROVERS_REQUEST,
  })

  export const deleteStockTransferApproversSuccess = (data) => ({
    type: DELETE_STOCK_TRANSFER_APPROVERS_SUCCESS,
    payload: data,
  })

  export const deleteStockTransferApproversError = (error) => ({
    type: DELETE_STOCK_TRANSFER_APPROVERS_ERROR,
    payload: error,
  })

  export const resetSave = () => (dispatch) =>  {
    dispatch(resetUseConsumeApprovers())
  }
  
  export const resetUseConsumeApprovers = () => ({
    type: USAGE_CONSUMPTION_RESET,
  
  })